const factsheets = [
	{
		id: 'data-saves-lives',
		image: 'YRBS_Factsheet',
		title: 'Data Saves Lives',
		file: {
			type: 'pdf',
			size: '1.1MB',
			url: 'https://www.healthydelaware.org/documents/community/toolkits/school-health-wellness/YRBS_Factsheet.pdf'
		}
	},
	{
		id: 'general',
		image: 'YRBS_General_factsheet',
		title: 'General',
		file: {
			type: 'pdf',
			size: '256KB',
			url: 'https://ddph-healthydelaware.s3.amazonaws.com/Community-Partners/YRBS_GeneralYRBS_factsheet.pdf'
		}
	},
	{
		id: 'covid',
		image: 'YRBS_COVID_factsheet',
		title: 'COVID',
		file: {
			type: 'pdf',
			size: '222KB',
			url: 'https://ddph-healthydelaware.s3.amazonaws.com/Community-Partners/YRBS_COVID_factsheet.pdf'
		}
	},
	{
		id: 'lifestyle',
		image: 'YRBS_Lifestyle_factsheet',
		title: 'Lifestyle',
		file: {
			type: 'pdf',
			size: '211KB',
			url: 'https://ddph-healthydelaware.s3.amazonaws.com/Community-Partners/YRBS_Lifestyle_factsheet.pdf'
		}
	},
	{
		id: 'mental-health',
		image: 'YRBS_MentalHealth_factsheet',
		title: 'Mental Health',
		file: {
			type: 'pdf',
			size: '237KB',
			url: 'https://ddph-healthydelaware.s3.amazonaws.com/Community-Partners/YRBS_MentalHealth_factsheet.pdf'
		}
	},
	{
		id: 'smoking-drinking',
		image: 'YRBS_SmokingDrinking_factsheet',
		title: 'Smoking/Drinking',
		file: {
			type: 'pdf',
			size: '264KB',
			url: 'https://ddph-healthydelaware.s3.amazonaws.com/Community-Partners/YRBS_SmokingDrinking_factsheet.pdf'
		}
	}
];

export default factsheets;
